import * as React from 'react';
import { useState } from 'react'
import { Outlet, useNavigate } from "react-router-dom";
import { useThemeMode } from '../ThemeContext';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RobotIcon from '@mui/icons-material/Android'; // Import the Robot icon
import NotificationsIcon from '@mui/icons-material/Notifications'; // Import the Alert icon
import SettingsIcon from '@mui/icons-material/Settings'; // Import the Settings icon
import LogoutIcon from '@mui/icons-material/Logout'; // Import the Logout icon
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import whiteCertisLogo from '../utils/images/white_certis_logo.png';
import Tooltip from '@mui/material/Tooltip';
import decodeJWT from '../utils/JWTDecoder';
import { useKeycloak } from '@react-keycloak/web';


const drawerWidth = 240;


const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })((
  { theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));



export default function MiniDrawer() {
  const theme = useTheme();
  const { keycloak } = useKeycloak();
  const { mode, toggleTheme } = useThemeMode();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const accountMenuOpen = Boolean(anchorEl);

  const decoded = decodeJWT(keycloak.token)
  const roles = decoded.resource_access.frontend?.roles
  const isAdmin = roles.includes("admin")

  // TO BE REDO WITH PROPER PERMISSION AND RBAC

  const admin_pages = [
    // {
    //     name: "Dashboard",
    //     link: "/dashboard",
    //     icon: <InboxIcon /> // Default icon for Dashboard
    // },
    {
        name: "Robots",
        link: "/robots",
        icon: <RobotIcon /> // Icon for Robots page
    },
    {
        name: "Managements",
        link: "/managements",
        icon: <SettingsIcon /> // Icon for Managements page
    },
    {
        name: "Alert",
        link: "/alerts",
        icon: <NotificationsIcon /> // Icon for Alert page
    },
    {
        name: "Robot Control",
        link: "/robot_control",
        icon: <SportsEsportsIcon /> // Icon for Robot Control page
    },

    // {
    //     name: "Missions",
    //     link: "/missions",
    //     icon: ""
    // },
    // {
    //     name: "Reports",
    //     link: "/reports",
    //     icon: ""
    // },
    // {
    //     name: "Scheduling",
    //     link: "/scheduling",
    //     icon: ""
    // },
    // {
    //     name: "Software",
    //     link: "/software",
    //     icon: ""
    // },
    // {
    //     name: "Tasklist",
    //     link: "/tasklist",
    //     icon: <CalendarMonthIcon/>
    // },
        // {
    //     name: "Intervention",
    //     link: "/intervention",
    //     icon: ""
    // },
    // {
    //     name: "Issues",
    //     link: "/issues",
    //     icon: ""
  ]

  const operator_pages = [
    {
        name: "Robots",
        link: "/robots",
        icon: <RobotIcon /> // Icon for Robots page
    },
    {
        name: "Alert",
        link: "/alerts",
        icon: <NotificationsIcon /> // Icon for Alert page
    },
  ]

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleAccountClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleAccountClose = () => {
    setAnchorEl(null);
  };

  const handleLogoClick = () => {
    navigate("/robots");
  };

  const handleProfileClick = () => {
    navigate("/profile");
  };


  // Get user initials from Keycloak user information
  const getUserInitials = () => {
    const username = keycloak.tokenParsed?.preferred_username || "User";
    const nameParts = username.split(" ");
    if (nameParts.length === 1) {
      return nameParts[0][0].toUpperCase();
    } else {
      return nameParts[0][0].toUpperCase() + nameParts[1][0].toUpperCase();
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ marginRight: 5, ...(open && { display: 'none' }) }}
          >
            <MenuIcon />
          </IconButton>
          <IconButton
            onClick={handleLogoClick}
            edge="start"
            sx={{ marginRight: 2 }}
          >
            <img src={whiteCertisLogo} alt="Certis Logo" style={{ height: 50 }} />
          </IconButton>
          <Typography variant="h4" noWrap component="div" sx={{ flexGrow: 1 }}></Typography>

          {/* Theme Toggle & Account */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Tooltip title={mode === 'night' ? 'Switch to Day Mode' : 'Switch to Night Mode'}>
              <IconButton onClick={toggleTheme} color="inherit">
                {mode === 'night' ? <LightModeIcon /> : <DarkModeIcon />}
              </IconButton>
            </Tooltip>

            <Tooltip title={keycloak.tokenParsed?.preferred_username || "Account settings"}>
            <IconButton
             onClick={handleAccountClick}
             size="big"
             aria-controls={accountMenuOpen ? 'account-menu' : undefined}
             aria-haspopup="true"
             aria-expanded={accountMenuOpen ? 'true' : undefined}
             >
             <Avatar sx={{ width: 40, height: 40 }}>
             {getUserInitials()} {/* Display user initials */}
             </Avatar>
             </IconButton>
             </Tooltip>
          </Box>

          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={accountMenuOpen}
            onClose={handleAccountClose}
            onClick={handleAccountClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&::before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <MenuItem onClick={handleProfileClick}>
              <Avatar sx={{ mr: 1 }} />
              Profile
            </MenuItem>

            <MenuItem onClick={() => navigate('/security')}>
            <ManageAccountsIcon fontSize="small" sx={{ mr: 1 }} />
            Security
            </MenuItem>


            <Divider />
            <MenuItem onClick={() => keycloak.logout()}>
              <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {isAdmin ? admin_pages.map((page, index) => (
            <ListItem key={page.name} disablePadding>
              <ListItemButton onClick={() => navigate(page.link)}>
                <ListItemIcon>
                  {page.icon}
                </ListItemIcon>
                <ListItemText primary={page.name} />
              </ListItemButton>
            </ListItem>
          )) : operator_pages.map((page, index) => (
            <ListItem key={page.name} disablePadding>
              <ListItemButton onClick={() => navigate(page.link)}>
                <ListItemIcon>
                  {page.icon}
                </ListItemIcon>
                <ListItemText primary={page.name} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3, bgcolor: 'background.default' }}>
        <DrawerHeader />
        <Outlet />
      </Box>
    </Box>
  );
}